import React from "react";
import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Line,
  ResponsiveContainer
} from "recharts";
import PropTypes from "prop-types";
import { useLightTheme } from "../../../hooks/useLightTheme";

const formatChartData = (data) => {
  const emptyCell = { name: "", values: [] };
  const finalData = [emptyCell];

  data.data.map((day) => {
    const dayVals = {};
    Object.assign(dayVals, { name: day.name });
    day.values.map((val, index) => {
      const metric = data.metrics[index];
      Object.assign(dayVals, { [metric]: val });
    });
    finalData.push(dayVals);
  });

  finalData.push(emptyCell);
  return finalData;
};

export function ComposedChartModule({ chartData }) {
  const isLight = useLightTheme();
  const tickStyle = isLight ? { fill: "#717173" } : undefined;
  const gridStroke = isLight ? "#e6e7e8" : "#696969";

  return (
    <ResponsiveContainer width="100%" height={300}>
      <ComposedChart data={formatChartData(chartData)}>
        <CartesianGrid strokeDasharray="3 3" stroke={gridStroke} />
        <XAxis dataKey="name" tick={tickStyle} />
        <YAxis tick={tickStyle} />
        <Tooltip
          cursor={false}
          labelStyle={{ color: "black" }}
          contentStyle={{ textAlign: "left" }}
        />
        <Legend
          verticalAlign="top"
          align="left"
          iconType="rect"
          height={60}
          wrapperStyle={{ paddingLeft: 40 }}
        />
        <Bar type="monotone" dataKey="Intros Booked" fill="#4667d4" stroke="#4667d4" />
        <Bar dataKey="Booking Shows" fill="#95adf7" />
        <Line type="monotone" dataKey="Class Conversion" stroke="#ff7300" />
      </ComposedChart>
    </ResponsiveContainer>
  );
}

ComposedChartModule.propTypes = {
  chartData: PropTypes.object
};

ComposedChartModule.defaultProps = {
  chartData: {
    metrics: [],
    data: []
  },
  colors: ["#4667d4", "#2651ac", "#95adf7"]
};

export default ComposedChartModule;
